// All these constants are exported.
export var MUI_DOCS_DOMAIN = 'https://mui.com';
export var GRID_ROW_HEIGHT = 34;
export var GRID_ROW_HEIGHT_DENSE = 28;
export var GRID_ROW_HEIGHT_LARGE = 57;
export var GRID_ROW_HEIGHT_XLARGE = 76;
export var ICON_SIZE_MAP = {
    xxs: 8,
    xs: 12,
    sm: 16,
    md: 20,
    lg: 24,
    xl: 32,
    xxl: 48,
};
